// ABOUTME: Ponto de entrada do Stimulus — registra controllers do layout e da aplicação.
// ABOUTME: Ativa debug/warnings em development via meta tag de environment.

import { Application } from "@hotwired/stimulus"
import { railsEnv, layoutControllers } from "@uenf/layout"

const application = Application.start()

if (railsEnv === "development") {
  application.warnings = true
  application.debug    = true
  window.Stimulus      = application
}

for (const [name, controller] of Object.entries(layoutControllers)) {
  application.register(name, controller);
}

import { definitions } from "stimulus:./controllers"
application.load(definitions);

import AutocompleteController from "@uenf/layout/controllers/autocomplete";
application.register("autocomplete", AutocompleteController);
